import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import InboxList from 'container/InboxList';
import InboxListWithDetail from 'container/InboxListWithDetail';

import { createAction } from 'utils';
import {
  getDocumentHeight,
  getScrollTop,
  getWindowHeight,
  detectIsMobileByScreenWidth,
} from 'utils/ScreenUtils';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import i18n from 'utils/I18n';
import { inMiniProgram } from 'utils/WeChatUtil';

const mapStateToProps = (state) => {
  return {
    language: state.users.language,
    messageList: state.inboxMessages.messageList,
  };
};
function Inbox({ language, messageList }) {
  const [showMobilePage, setShowMobilePage] = useState(detectIsMobileByScreenWidth());

  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams()
  const location = useLocation();

  const parsed = queryString.parse(location.search);

  const updateWindowDimensions = () => {
    setShowMobilePage(detectIsMobileByScreenWidth() || inMiniProgram());
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (messageList?.length > 0) {
      // not refresh message list when back from inbox detail page
      return;
    }
    // refresh messages when list empty
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
    dispatch(createAction('inboxMessages/refreshMessages')());
  }, []);

  useEffect(() => {
    if (inMiniProgram() && parsed.subscribed === "true") {
      setTimeout(() => {
        dispatch({
          type: 'navBars/updateState',
          payload: {
            toastShowing: {
              value: true,
              content: i18n.t("notificationsEnabled"),
              showTickIcon: true
            },
          },
        })
      }, 100)
    }
  }, [parsed.subscribed]);

  if (showMobilePage) {
    return <InboxList />;
  }
  return <InboxListWithDetail />;
}

export default connect(mapStateToProps)(Inbox);
